import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';
import useCBU from 'features/reports/model/playerDeposits/useCBU';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';
import Select from 'components/Select/desktop';

import crossSVG from 'shared/img/cross-transparent.svg';
import arrowSVG from 'shared/img/arrow.svg';

import './Requisite.scss';

const b = block('player-deposits-requisite-desktop');

const Requisite = () => {
  const locale = useSelector(s => s.locale.locale);

  const { state, handlers, out } = useCBU();

  const RequisitesForm = ({ requisites, opened }) => {
    return (
      <div className={b('modal-container', { opened })}>
        <div className={b('items-container')}>
          {requisites && (
            <div className={b('item-header')}>
              <div className={b('item-header-title')}>{requisites.titular}</div>
              <SVG
                svgProps={{ svg: arrowSVG }}
                className={b('arrow')}
                onClick={() => handlers.toggleItem(requisites.id)}
              />
            </div>
          )}

          {opened && (
            <>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.owner}</div>
                <div className={b('item-field')}>
                  <Input
                    size="low"
                    value={state.values.titular}
                    onChange={e => handlers.handleValueChange('titular', e.target.value)}
                    placeholder={locale.owner}
                  />
                </div>
              </div>

              <div className={b('item')}>
                <div className={b('item-label')}>{locale.bank}</div>
                <div className={b('item-field')}>
                  <Select
                    items={out.banks}
                    activeItem={state.values.activeBankSelector}
                    onChange={handlers.handleSelectBank}
                  />
                </div>
              </div>

              <div className={b('item')}>
                <div className={b('item-label')}>{locale.additionalInfo}</div>
                <div className={b('information')}>{locale.minimalDeposit}: 1500 ARS</div>
              </div>

              <div className={b('item')}>
                <div className={b('item-label')}>{locale.details}</div>
                <div className={b('item-field')}>
                  <Input
                    size="low"
                    value={state.values.details}
                    onChange={e => handlers.handleValueChange('details', e.target.value)}
                    placeholder={locale.details}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        {opened && (
          <div className={b('button')}>
            <Button
              callBack={requisites ? handlers.handleDeleteBank : () => handlers.handleAddRequisites(false)}
              color="transparent"
              text={locale.deleteBankDetails}
              type="submit"
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={b()}>
      <div className={b('button')}>
        <Button text={locale.bankDetails} callBack={() => handlers.setIsModalOpen(true)} />
      </div>

      {state.isModalOpen && (
        <Modal
          closeFunction={() => handlers.setIsModalOpen(false)}
          content={
            <form
              className={b('modal')}
              onSubmit={state.values.addRequisites ? handlers.handleCreateBank : handlers.handleUpdateBank}>
              <SVG svgProps={{ svg: crossSVG }} className={b('close')} onClick={() => handlers.setIsModalOpen(false)} />
              <h3 className={b('modal-title')}>{locale.bankDetails}</h3>
              {state.currentRequisites.map(requisites => {
                const opened = state.values.openedItemId === requisites.id;

                return RequisitesForm({ requisites, opened });
              })}

              {state.values.addRequisites && RequisitesForm({ opened: true })}

              <div onClick={() => handlers.handleAddRequisites(true)} className={b('add')}>
                +
              </div>

              <div className={b('button')}>
                <Button text={locale.save} type="submit" disabled={out.disabled} />
              </div>
            </form>
          }
        />
      )}
    </div>
  );
};

export default Requisite;
